import { render, staticRenderFns } from "./PaginatedTables.vue?vue&type=template&id=65c07c9a&scoped=true"
import script from "./PaginatedTables.vue?vue&type=script&lang=js"
export * from "./PaginatedTables.vue?vue&type=script&lang=js"
import style0 from "./PaginatedTables.vue?vue&type=style&index=0&id=65c07c9a&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c07c9a",
  null
  
)

export default component.exports